<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="text-right" v-if="!readonly">
          <form-button :indicator="form.processing()" v-on:clicked="submit">
            Save
          </form-button>
        </div>
        <div class="clearfix"></div>
        <hr />

        <fieldset>
          <legend>
            Recommend Occupants for personal Injury
            <small class="text-muted">
              - select the occupants
            </small>
          </legend>
          <div class="card-body">
            <table class="table table-striped table-bordered table-centered">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Party</th>
                  <th>Notes</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!occupants.length">
                  <td class="text-center" colspan="5">
                    There are currently no occupants for the selected party.
                  </td>
                </tr>

                <tr v-bind:key="index" v-for="(occupant, index) in occupants">
                  <td>{{ occupant.first_name }} {{ occupant.last_name }}</td>
                  <td>{{ getOccupantPartyType(occupant) }}</td>
                  <td>
                    {{
                      occupant.has_representation
                        ? 'Already have representation'
                        : ''
                    }}
                  </td>
                  <td>
                    <div v-if="!occupant.has_representation">
                      <toggleswitch
                        :labels="true"
                        :name="occupant.identifier"
                        labelColumn="col-8"
                        inputColumn="col-4"
                        :checked="selected(occupant.identifier)"
                        @change="toggle(occupant.identifier)"
                      ></toggleswitch>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <company-select
              id="personal-injury-company"
              :company="getPICompany"
              ref="piCompany"
            ></company-select>
          </div>
        </fieldset>
      </div>
      <div class="card-footer text-right" v-if="!readonly">
        <form-button :indicator="form.processing()" v-on:clicked="submit">
          Save
        </form-button>
      </div>
    </fieldset>
  </form>
</template>

<script>
import Company from './../Shared/Company';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    selectedService: {
      type: Object,
      required: false,
      default: null
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    'company-select': Company
  },
  data() {
    return {
      form: new window.Form({
        occupants: [],
        service_id: null,
        occupant_type: null,
        company_id: null,
        company_name: null,
        company_email_address: null,
        company_telephone_number: null,
        company_address_line_one: null,
        company_address_line_two: null,
        company_city: null,
        company_postcode: null
      }),
      personalInjuries: [],
      personal_injury_exists: false,
      data_entered: false,
      selectedPartyType: null,
      partyTypes: [
        { name: 'client', label: 'Client' },
        { name: 'third_party', label: 'Third Party' }
      ],
      indicator: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    personalInjury() {
      return this.$store.getters['Incident/personalInjury'];
    },

    hasPersonalInjury() {
      return !!this.personalInjury.length;
    },

    occupants() {
      return [
        ...this.$store.getters['Incident/occupants'],
        ...this.$store.getters['Incident/thirdPartyOccupants']
      ];
    },

    getPICompany() {
      return {
        company_id: this.form.company_id,
        name: this.form.company_name,
        email_address: this.form.company_email_address,
        telephone_number: this.form.company_telephone_number,
        address_line_one: this.form.company_address_line_one,
        address_line_two: this.form.company_address_line_two,
        city: this.form.company_city,
        postcode: this.form.company_postcode
      };
    }
  },

  methods: {
    mount() {
      this.updateOccupantList();

      if (this.personalInjury && this.personalInjury.identifier) {
        this.setPersonalInjury();
      }
    },

    getOccupantPartyType(occupant) {
      if (occupant.third_party_id) {
        return 'Third Party';
      }

      return 'Client';
    },

    setPersonalInjury() {
      this.personal_injury_exists = true;
    },

    setPICompany(company) {
      this.form.company_id = company.company_id;
      this.form.company_name = company.name;
      this.form.company_email_address = company.email_address;
      this.form.company_telephone_number = company.telephone_number;
      this.form.company_address_line_one = company.address_line_one;
      this.form.company_address_line_two = company.address_line_two;
      this.form.company_city = company.city;
      this.form.company_postcode = company.postcode;
    },

    resetPICompany() {
      this.form.company_id = null;
      this.form.company_name = null;
      this.form.company_email_address = null;
      this.form.company_telephone_number = null;
      this.form.company_address_line_one = null;
      this.form.company_address_line_two = null;
      this.form.company_city = null;
      this.form.company_postcode = null;
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    selected(occupant) {
      return this.personalInjuries.includes(occupant);
    },

    toggle(occupant) {
      if (this.selected(occupant)) {
        const index = this.personalInjuries.indexOf(occupant);

        this.personalInjuries.splice(index, 1);
      } else {
        this.personalInjuries.push(occupant);
      }
    },

    updateOccupantList() {
      if (this.hasPersonalInjury) {
        this.personalInjuries = [];

        this.resetPICompany();

        this.personalInjury.forEach(pi => {
          this.personalInjuries.push(pi.party.identifier);

          this.setPICompany(pi);
        });
      }
    },

    submit() {
      if (this.readonly) return;
      this.form.occupants = this.personalInjuries.map(identifier => {
        const occupant = this.occupants.find(
          occupant => occupant.identifier === identifier
        );

        return {
          occupant_type: occupant?.third_party_id ? 'third_party' : 'client',
          occupant_id: occupant?.id
        };
      });

      this.setPICompany(this.$refs.piCompany.form);

      if (this.selectedService) {
        this.form.service_id = this.selectedService.id;
      }

      if (this.form.occupants.length > 0) {
        this.form
          .post(`/incidents/${this.incident}/services/injury`)
          .then(data => {
            this.$store.commit('Incident/setPersonalInjury', data);

            this.$emit('added', data);

            window.toastify.success(
              'Saved',
              'The personal injury details were saved successfully!'
            );
          })
          .catch(error => {
            window.toastify.error(
              'Error',
              'Sorry, there was an error saving the personal injury details.'
            );
          });
      } else {
        window.toastify.error(
          'Error',
          'Sorry, there was an error saving the personal injury details, please select an occupant.'
        );
      }
    }
  },
  watch: {
    selectedPartyType() {
      this.updateOccupantList();
    },

    personalInjury() {
      this.updateOccupantList();
    }
  }
};
</script>
